const base64ToBlob = (heatmap) => {
    const { ContentType, HeatMapImg } = heatmap;
    if (!ContentType || !HeatMapImg) return null;
    // https://stackoverflow.com/a/12300351
    const byteString = atob(HeatMapImg);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: ContentType });
    return URL.createObjectURL(blob);
};

export {
    base64ToBlob,
};
